import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ResourceWorkgroupDepartmentViewModel } from "../view-models/resource-workgroup-department.view-model";
import { ApiBaseService } from "../../../../_api/services/api-base.service";
import { ConfigService } from "../../../../shared/services/config.service";
import { UserService } from "../../../../shared/services/user.service";

@Injectable({
  providedIn: "root"
})
export class ResourcesService extends ApiBaseService {

  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "Content-Type": "application/json", APIKEY: "ams-direct-api-production-key", SessionId: this.userService.sessionId }) };
    this.baseUrl = `${this.configService.config.productionUrl}/api/resource`;
  }

  get(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/get?id=${id}`, this.httpOptions)
      .pipe(catchError(this.handleError<any>("Failed to get resource", [])));
  }

  getResourceWorkgroupDepartmentTree(): Observable<ResourceWorkgroupDepartmentViewModel[]> {
    return this.http.get<ResourceWorkgroupDepartmentViewModel[]>(`${this.baseUrl}/getresourceworkgroupdepartmenttree`, this.httpOptions)
      .pipe(catchError(this.handleError<ResourceWorkgroupDepartmentViewModel[]>("Failed to get resources hierarchy tree", [])));
  }
}
